var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React from 'react';
import { observer } from 'mobx-react';
let AbfragerAnswerBottomFeedbackTime = class AbfragerAnswerBottomFeedbackTime extends React.PureComponent {
    render() {
        const { question } = this.props;
        const remainingTimeInSeconds = question.answeringFeedback.remainingFeedbackTimeInSeconds;
        if (remainingTimeInSeconds <= 0)
            return null;
        return (React.createElement("div", { style: { flex: '0 1 auto' } },
            React.createElement("span", { "data-aspect": "feedbackTime", style: {
                    fontWeight: 'bold',
                    color: '#555',
                    marginRight: 20,
                    fontSize: 14,
                    position: 'relative',
                    top: 2
                } }, remainingTimeInSeconds)));
    }
};
AbfragerAnswerBottomFeedbackTime = __decorate([
    observer
], AbfragerAnswerBottomFeedbackTime);
export { AbfragerAnswerBottomFeedbackTime };
